module.exports = __webpack_public_path__ + "img/close-notice@2x.6abe4381.svg";